import React from "react";
const fonts = ["Cairo", "Tajawal", "Amiri", "Arial", "Tahoma", "Roboto"];

export default function LayerEditor({ layer, updateLayer, deleteLayer, canvas, handleUpload, fileTextBgImgRef, fileTextBgVideoRef }) {
  if (!layer) return null;
  const isNumber = v => !isNaN(Number(v));
  
  const getLayerTypeName = (type) => {
    switch (type) {
      case "text": return "نص";
      case "image": return "صورة";
      case "video": return "فيديو";
      case "audio": return "صوت";
      case "gif": return "GIF متحرك";
      default: return "طبقة";
    }
  };

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 15
    }} className="layer-editor-grid">
      {/* العمود الأول */}
      <div>
        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
            <input 
              type="checkbox" 
              checked={layer.visible !== false}
              onChange={e => updateLayer(layer.id, { visible: e.target.checked })}
              style={{ transform: "scale(1.2)" }}
            />
            <span style={{ fontWeight: "bold", color: "var(--text-primary)" }}>
              إظهار الطبقة
            </span>
          </label>
        </div>

        {layer.type === "text" && (
          <>
            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                النص:
              </label>
              <input 
                type="text" 
                value={layer.content}
                onChange={e => updateLayer(layer.id, { content: e.target.value })}
                style={{ 
                  width: "100%", 
                  padding: "8px", 
                  border: "1px solid var(--border-color)", 
                  borderRadius: 6,
                  fontSize: 14,
                  background: "var(--bg-secondary)",
                  color: "var(--text-primary)"
                }} 
              />
            </div>
            
            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                الخط:
              </label>
              <select 
                value={layer.font}
                onChange={e => updateLayer(layer.id, { font: e.target.value })}
                style={{ 
                  width: "100%", 
                  padding: "8px", 
                  border: "1px solid var(--border-color)", 
                  borderRadius: 6,
                  fontSize: 14,
                  background: "var(--bg-secondary)",
                  color: "var(--text-primary)"
                }}
              >
                {fonts.map(f => <option key={f} value={f}>{f}</option>)}
              </select>
            </div>

            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                حجم الخط:
              </label>
              <input 
                type="range" 
                min={10} 
                max={160} 
                value={layer.fontSize}
                onChange={e => updateLayer(layer.id, { fontSize: Number(e.target.value) })}
                style={{ width: "100%" }}
              />
              <div style={{ textAlign: "center", fontSize: 12, color: "var(--text-secondary)", marginTop: 5 }}>
                {layer.fontSize}px
              </div>
            </div>

            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                لون النص:
              </label>
              <input 
                type="color" 
                value={layer.color}
                onChange={e => updateLayer(layer.id, { color: e.target.value })}
                style={{ 
                  width: "100%", 
                  height: "40px", 
                  border: "1px solid var(--border-color)", 
                  borderRadius: 6,
                  cursor: "pointer"
                }}
              />
            </div>

            {/* خلفية النص */}
            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                خلفية النص:
              </label>
              <select 
                value={layer.backgroundType || "none"}
                onChange={e => updateLayer(layer.id, { backgroundType: e.target.value })}
                style={{ 
                  width: "100%", 
                  padding: "8px", 
                  border: "1px solid var(--border-color)", 
                  borderRadius: 6,
                  fontSize: 14,
                  background: "var(--bg-secondary)",
                  color: "var(--text-primary)",
                  marginBottom: 10
                }}
              >
                <option value="none">بلا خلفية</option>
                <option value="color">لون خلفية</option>
                <option value="image">صورة خلفية</option>
                <option value="video">فيديو خلفية</option>
              </select>

              {/* لون الخلفية */}
              {layer.backgroundType === "color" && (
                <div style={{ marginBottom: 10 }}>
                  <input 
                    type="color" 
                    value={layer.backgroundColor || "#000000"}
                    onChange={e => updateLayer(layer.id, { backgroundColor: e.target.value })}
                    style={{ 
                      width: "100%", 
                      height: "40px", 
                      border: "1px solid var(--border-color)", 
                      borderRadius: 6,
                      cursor: "pointer"
                    }}
                  />
                </div>
              )}

              {/* صورة الخلفية */}
              {layer.backgroundType === "image" && (
                <div style={{ marginBottom: 10 }}>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                    <button
                      onClick={() => fileTextBgImgRef.current?.click()}
                      style={{
                        background: 'var(--button-bg)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '6px 12px',
                        fontSize: '12px',
                        cursor: 'pointer',
                        flex: 1
                      }}
                    >
                      📁 رفع صورة
                    </button>
                  </div>
                  <input 
                    type="text" 
                    value={layer.backgroundImage || ""}
                    onChange={e => updateLayer(layer.id, { backgroundImage: e.target.value })}
                    placeholder="رابط الصورة أو مسار الملف"
                    style={{ 
                      width: "100%", 
                      padding: "8px", 
                      border: "1px solid var(--border-color)", 
                      borderRadius: 6,
                      fontSize: 14,
                      background: "var(--bg-secondary)",
                      color: "var(--text-primary)"
                    }}
                  />
                </div>
              )}

              {/* فيديو الخلفية */}
              {layer.backgroundType === "video" && (
                <div style={{ marginBottom: 10 }}>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                    <button
                      onClick={() => fileTextBgVideoRef.current?.click()}
                      style={{
                        background: 'var(--button-bg)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '6px 12px',
                        fontSize: '12px',
                        cursor: 'pointer',
                        flex: 1
                      }}
                    >
                      🎬 رفع فيديو
                    </button>
                  </div>
                  <input 
                    type="text" 
                    value={layer.backgroundVideo || ""}
                    onChange={e => updateLayer(layer.id, { backgroundVideo: e.target.value })}
                    placeholder="رابط الفيديو أو مسار الملف"
                    style={{ 
                      width: "100%", 
                      padding: "8px", 
                      border: "1px solid var(--border-color)", 
                      borderRadius: 6,
                      fontSize: 14,
                      background: "var(--bg-secondary)",
                      color: "var(--text-primary)"
                    }}
                  />
                </div>
              )}

              {/* إعدادات الخلفية */}
              {(layer.backgroundType === "color" || layer.backgroundType === "image" || layer.backgroundType === "video") && (
                <>
                  <div style={{ marginBottom: 10 }}>
                    <label style={{ display: "block", marginBottom: 5, fontSize: 12, color: "var(--text-secondary)" }}>
                      شفافية الخلفية: {Math.round((layer.backgroundOpacity || 1) * 100)}%
                    </label>
                    <input 
                      type="range" 
                      min={0} 
                      max={1} 
                      step={0.05} 
                      value={layer.backgroundOpacity || 1}
                      onChange={e => updateLayer(layer.id, { backgroundOpacity: Number(e.target.value) })}
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div style={{ marginBottom: 10 }}>
                    <label style={{ display: "block", marginBottom: 5, fontSize: 12, color: "var(--text-secondary)" }}>
                      الحشو الداخلي:
                    </label>
                    <input 
                      type="range" 
                      min={0} 
                      max={50} 
                      step={1} 
                      value={layer.backgroundPadding || 10}
                      onChange={e => updateLayer(layer.id, { backgroundPadding: Number(e.target.value) })}
                      style={{ width: "100%" }}
                    />
                    <div style={{ textAlign: "center", fontSize: 12, color: "var(--text-secondary)", marginTop: 5 }}>
                      {layer.backgroundPadding || 10}px
                    </div>
                  </div>

                  <div style={{ marginBottom: 10 }}>
                    <label style={{ display: "block", marginBottom: 5, fontSize: 12, color: "var(--text-secondary)" }}>
                      نصف قطر الزوايا:
                    </label>
                    <input 
                      type="range" 
                      min={0} 
                      max={50} 
                      step={1} 
                      value={layer.backgroundRadius || 0}
                      onChange={e => updateLayer(layer.id, { backgroundRadius: Number(e.target.value) })}
                      style={{ width: "100%" }}
                    />
                    <div style={{ textAlign: "center", fontSize: 12, color: "var(--text-secondary)", marginTop: 5 }}>
                      {layer.backgroundRadius || 0}px
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}

        {(layer.type === "image" || layer.type === "gif" || layer.type === "video") && (
          <>
            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                العرض:
              </label>
              <input 
                type="range" 
                min={10} 
                max={canvas.width} 
                value={layer.width}
                onChange={e => isNumber(e.target.value) && updateLayer(layer.id, { width: Number(e.target.value) })}
                style={{ width: "100%" }}
              />
              <div style={{ textAlign: "center", fontSize: 12, color: "var(--text-secondary)", marginTop: 5 }}>
                {layer.width}px
              </div>
            </div>

            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                الارتفاع:
              </label>
              <input 
                type="range" 
                min={10} 
                max={canvas.height} 
                value={layer.height}
                onChange={e => isNumber(e.target.value) && updateLayer(layer.id, { height: Number(e.target.value) })}
                style={{ width: "100%" }}
              />
              <div style={{ textAlign: "center", fontSize: 12, color: "var(--text-secondary)", marginTop: 5 }}>
                {layer.height}px
              </div>
            </div>
          </>
        )}

        {layer.type === "audio" && (
          <div style={{ marginBottom: 15 }}>
            <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
              عرض مشغل الصوت:
            </label>
            <input 
              type="range" 
              min={80} 
              max={canvas.width} 
              value={layer.width}
              onChange={e => isNumber(e.target.value) && updateLayer(layer.id, { width: Number(e.target.value) })}
              style={{ width: "100%" }}
            />
            <div style={{ textAlign: "center", fontSize: 12, color: "var(--text-secondary)", marginTop: 5 }}>
              {layer.width}px
            </div>
          </div>
        )}
      </div>

      {/* العمود الثاني */}
      <div>
        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
            الشفافية: {Math.round(layer.opacity * 100)}%
          </label>
          <input 
            type="range" 
            min={0} 
            max={1} 
            step={0.05} 
            value={layer.opacity}
            onChange={e => isNumber(e.target.value) && updateLayer(layer.id, { opacity: Number(e.target.value) })}
            style={{ width: "100%" }}
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
            الدوران: {layer.rotation || 0}°
          </label>
          <input 
            type="range" 
            min={0} 
            max={360} 
            step={1} 
            value={layer.rotation || 0}
            onChange={e => isNumber(e.target.value) && updateLayer(layer.id, { rotation: Number(e.target.value) })}
            style={{ width: "100%" }}
          />
        </div>

        {layer.type === "video" && (
          <>
            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                <input 
                  type="checkbox" 
                  checked={!!layer.muted}
                  onChange={e => updateLayer(layer.id, { muted: e.target.checked })}
                  style={{ transform: "scale(1.2)" }}
                />
                <span style={{ fontWeight: "bold", color: "var(--text-primary)" }}>
                  كتم الصوت
                </span>
              </label>
            </div>

            <div style={{ marginBottom: 15 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                <input 
                  type="checkbox" 
                  checked={!!layer.showControls}
                  onChange={e => updateLayer(layer.id, { showControls: e.target.checked })}
                  style={{ transform: "scale(1.2)" }}
                />
                <span style={{ fontWeight: "bold", color: "var(--text-primary)" }}>
                  إظهار أزرار التحكم
                </span>
              </label>
            </div>
          </>
        )}

        <div style={{ marginTop: 20 }}>
          <button 
            onClick={() => deleteLayer(layer.id)}
            style={{
              background: "var(--danger-color)",
              color: "#fff",
              border: 0,
              padding: "10px 20px",
              borderRadius: 6,
              cursor: "pointer",
              fontSize: 14,
              fontWeight: "bold",
              width: "100%",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.02)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
            }}
          >
            🗑️ حذف {getLayerTypeName(layer.type)}
          </button>
        </div>
      </div>
    </div>
  );
}
